import bg_home from 'assets/images/bgPC.jpg';
import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home}
        alt="Background"
        className="min-h-full min-w-full fixed right-0 bottom-0 object-cover"
      />
      <div className="container relative z-10">
        <Header />

        {/* Header Cơ Cấu Giải Thưởng */}
        <div className="flex justify-center items-start md:p-10 p-5 mt-10 mb-4 w-full h-auto min-h-[280px] relative bg-white rounded-[15px]">
          <div className="absolute top-[-25px] left-1/2 transform -translate-x-1/2 w-full md:max-w-[250px] max-w-[220px]">
            <img
              src="/assets/images/cocau/title.png"
              alt=""
              className="w-full h-full object-contain"
            />
          </div>

          {/* Bảng Cơ Cấu Giải Thưởng từ Figma */}
          <div className="w-full max-w-4xl mx-auto mt-8 px-2">
            <table className="w-full text-center" style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid black' }}>
                  <th className="text-sm sm:text-base md:text-lg font-bold text-[#157f3d] pb-3 sm:pb-4 font-roboto">
                    Cấp độ VIP
                  </th>
                  <th className="text-sm sm:text-base md:text-lg font-bold text-[#157f3d] pb-3 sm:pb-4 font-roboto">
                    Dự Đoán Tỷ Số
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid black' }}>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    VIP 0
                  </td>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    29
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid black' }}>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    VIP 1 - VIP 5
                  </td>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    99
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid black' }}>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    VIP 6 - VIP 10
                  </td>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    299
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid black' }}>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    VIP 11 - VIP 15
                  </td>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    999
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid black' }}>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    VIP 16 - VIP 20
                  </td>
                  <td className="text-xs sm:text-sm md:text-base font-normal text-[#333333] py-2 sm:py-2.5 md:py-3 font-roboto">
                    999
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <MatchResult />
      </div>
    </div>
  );
};

export default PrizeStructure;
